import { render, staticRenderFns } from "./store-detail.vue?vue&type=template&id=4abcceb7&scoped=true&"
import script from "./store-detail.vue?vue&type=script&lang=js&"
export * from "./store-detail.vue?vue&type=script&lang=js&"
import style0 from "./store-detail.vue?vue&type=style&index=0&id=4abcceb7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abcceb7",
  null
  
)

export default component.exports